import { COMMENTS_FETCH_REQUEST, COMMENTS_FETCH_SUCCESS, COMMENTS_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchCommentsRequest = () => {
    return {
        type: COMMENTS_FETCH_REQUEST
    }
}

const fetchCommentsSuccess = data => {
    return {
        type: COMMENTS_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchCommentsFailure = error => {
    return {
        type: COMMENTS_FETCH_FAILURE,
        payload: error,
    }
}


export const getComments = id => {

    if (id !== null) {


        return (dispatch) => {
            dispatch(fetchCommentsRequest());
            fetch(`${baseUrl}/feed_backs/${id}`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then((response) => {
                    dispatch(fetchCommentsSuccess(response));
                })
                .catch((error) => {
                    dispatch(fetchCommentsFailure(error.message));
                })
        }
    } else {
        return (dispatch) => dispatch(fetchCommentsSuccess({}));
    }
}